import { Map } from 'immutable';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import { fetchBanksAndBranch, fetchBranches } from '../services/backendService';
import { namespaceActionObject } from './helpers';

// TYPES
export const REDUCER_ACTIONS = namespaceActionObject('BANK')({
  FIRE_BANKS_FETCH: 'FIRE_BANK_FETCH',
  BANKS_FETCH_PENDING: 'BANKS_FETCH_PENDING',
  BANKS_FETCH_ERROR: 'BANKS_FETCH_ERROR',
  BANKS_FETCH_SUCCESS: 'BANKS_FETCH_SUCCESS',
  FIRE_BRANCH_FETCH: 'FIRE_BRANCH_FETCH',
  BRANCH_FETCH_PENDING: 'BRANCH_FETCH_PENDING',
  BRANCH_FETCH_ERROR: 'BRANCH_FETCH_ERROR',
  BRANCH_FETCH_SUCCESS: 'BRANCH_FETCH_SUCCESS',
  SET_USER_BANK_DATA: 'SET_USER_BANK_DATA'
});

export const REDUCER_STATUS = {
  BANKS_NOT_ASK: 'BANKS_NOT_ASK',
  BANKS_ASK: 'BANKS_ASK',
  BANKS_ERROR: 'BANKS_ERROR',
  BANKS_SUCCESS: 'BANKS_SUCCESS',
  BRANCH_ASK: 'BRANCH_ASK',
  BRANCH_SUCCESS: 'BRANCH_SUCCESS'
};

// ACTIONS
export const fireBanksFetch = () => ({
  type: REDUCER_ACTIONS.FIRE_BANKS_FETCH
});

export const banksFetchPending = () => ({
  type: REDUCER_ACTIONS.BANKS_FETCH_PENDING
});

export const banksFetchSuccess = banks => ({
  type: REDUCER_ACTIONS.BANKS_FETCH_SUCCESS,
  payload: banks
});

export const banksFetchError = error => ({
  type: REDUCER_ACTIONS.BANKS_FETCH_ERROR,
  payload: error
});

export const fireBranchesFetch = bankCode => ({
  type: REDUCER_ACTIONS.FIRE_BRANCH_FETCH,
  payload: bankCode
});

export const branchFetchPending = () => ({
  type: REDUCER_ACTIONS.BANKS_FETCH_PENDING
});

export const branchFetchSuccess = branch => ({
  type: REDUCER_ACTIONS.BRANCH_FETCH_SUCCESS,
  payload: branch
});

export const setUserBankData = bankData => ({
  type: REDUCER_ACTIONS.SET_USER_BANK_DATA,
  payload: bankData
});

export const branchFetchError = error => ({
  type: REDUCER_ACTIONS.BANKS_FETCH_ERROR,
  payload: error
});

// SAGAS

export function* watchFetchBanks() {
  yield takeEvery(REDUCER_ACTIONS.FIRE_BANKS_FETCH, fetchingBanks);
}

export function* watchFetchBranch() {
  yield takeEvery(REDUCER_ACTIONS.FIRE_BRANCH_FETCH, fetchingBranch);
}

export function* fetchingBanks() {
  try {
    yield put(banksFetchPending());
    const token = yield select(getAuthToken);
    const data = yield call(fetchBanksAndBranch, token);
    yield put(banksFetchSuccess(data.data));
  } catch (error) {
    console.log('cant fetch any banks');
  }
}

export function* fetchingBranch(action) {
  try {
    const token = yield select(getAuthToken);
    const data = yield call(fetchBranches, action.payload, token);
    yield put(branchFetchSuccess(data.data));
  } catch (error) {
    console.log('cant fetch branches');
  }
}

// STATE MAPPERS

export const getAuthToken = state => state.auth.get('token');
export const getBanks = state => state.banks.get('banks');
export const getUserBankData = state => state.banks.get('userBank');
export const getBranches = state => state.banks.get('branch');
export const isBanksPending = state => state.banks.get('status') === REDUCER_STATUS.BANKS_FETCH_PENDING;
export const didBanksFailed = state => state.banks.get('status') === REDUCER_STATUS.BANKS_ERROR;

const initialState = Map({
  status: REDUCER_STATUS.BANKS_NOT_ASK
});

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REDUCER_ACTIONS.FIRE_BANKS_FETCH:
      return state.set('status:', REDUCER_STATUS.BANKS_ASK);
    case REDUCER_ACTIONS.BANKS_FETCH_PENDING:
      return state.set('status', REDUCER_STATUS.BANKS_FETCH_PENDING);
    case REDUCER_ACTIONS.BANKS_FETCH_ERROR:
      return state.merge({ status: REDUCER_STATUS.BANKS_FETCH_ERROR, error: payload });
    case REDUCER_ACTIONS.BANKS_FETCH_SUCCESS:
      return state.merge({ status: REDUCER_STATUS.BANKS_SUCCESS, banks: payload });
    case REDUCER_ACTIONS.FIRE_BRANCH_FETCH:
      return state.set('status:', REDUCER_STATUS.BRANCH_ASK);
    case REDUCER_ACTIONS.BRANCH_FETCH_PENDING:
      return state.set('status', REDUCER_STATUS.BRANCH_FETCH_PENDING);
    case REDUCER_ACTIONS.BRANCH_FETCH_ERROR:
      return state.merge({ status: REDUCER_STATUS.BRANCH_FETCH_ERROR, error: payload });
    case REDUCER_ACTIONS.BRANCH_FETCH_SUCCESS:
      return state.merge({ status: REDUCER_STATUS.BRANCH_FETCH_SUCCESS, branch: payload });
    case REDUCER_ACTIONS.SET_USER_BANK_DATA:
      return state.merge({ userBank: payload });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/banks.js